<template>
    <div class="pt-32 px-3 md:px-4 mx-auto sm:px-6 max-w-7xl">
        <ElementsActionMessage v-if="!isProducer && (!user?.twofactor || user?.twofactor == 'off')" :actionMessage="{ code: 'activate-2fa', color: 'info', to: '/user/me/2fa' }" :pending="false" />
        <LazyHomePartialsMailConfirmation v-if="!user.confirmed" />
        <template v-else-if="isProducer">
            <ElementsActionMessage v-if="businesses?.data?.length && (!user?.twofactor || user?.twofactor == 'off')" :actionMessage="{ code: 'activate-2fa', color: 'info', to: '/user/me/2fa' }" :pending="false" />
            <LazyHomePartialsCreateBusiness v-if="pending || !businesses?.data?.length" :businesses="businesses" />
            <div class="py-6" v-else>
                <LazyBusinessCompactView />
                <LazyBusinessComponentProducts id="current" class="mt-8" />
            </div>
        </template>
        <LazyOrganizationDashboard v-else-if="isOrganisation || isCert" />
        <LazyAdminDashboard v-else-if="isAdmin" />
    </div>
</template>
<script setup>
const user = useStrapiUser()
const { find  } = useStrapi4()
const isProducer = useIsProducer()
const isOrganisation = useIsOrganisation()
const isCert = useIsCertification()
const isAdmin = useIsAdmin()


const { data: businesses, pending } = useLazyAsyncData(
    'businessesCheck',
    () => find('businesses', {
        filters: {
            users: { id: { $in: user.id } }
        }
    })  
)
</script>